import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AddressParamsModel, AddressSuggestResult, SuggestShortNameModel } from 'Models'
import { Callback } from 'Types/utilTypes'
import { TypeRequest, GET_SHORTNAME } from 'Modules'

type DadataState = {}

const initialState: DadataState = {}

export namespace DadataNS {
	export type GetAddress = PayloadAction<{
		params: AddressParamsModel
		typeRequest: TypeRequest
		callback?: (address: AddressSuggestResult) => void
		errorCallback?: Callback
	}>
	export type GetShortName = PayloadAction<{
		params: GET_SHORTNAME
		callback?: Callback<SuggestShortNameModel>
		errorCallback?: Callback
	}>
}

export const dadataSlice = createSlice({
	name: 'dadata',
	initialState,
	reducers: {
		getAddress: (state, action: DadataNS.GetAddress) => {},
		getShortName: (state, action: DadataNS.GetShortName) => {},
	},
})
